import { render, staticRenderFns } from "./FaqList.vue?vue&type=template&id=927b488e&"
import script from "./FaqList.vue?vue&type=script&lang=ts&"
export * from "./FaqList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports